module.exports = __webpack_public_path__ + "img/israfil.5550eeb9.jpg";